import React from "react";

import { useNavigate, useParams } from "react-router-dom";
import { buf2str, hex2buf } from "../../Utils/OstreonEncryption";
import { CheckEmail } from "./CheckEmail";
import { superRedactEmail } from "../../Utils/formatEmail";
import { generateKey } from "./Register";
import { useEffect } from "react";
import { useState } from "react";
import { getRegistrationRedirect } from "../../Utils/redirectUtils";

export function RegisterRedirection() {
    const navigate = useNavigate()
    const {redirect_id} = useParams()
    const [email, setEmail] = useState()
    
    window.scrollTo(0,0)
    useEffect(()=>{
        if(!redirect_id) return navigate('/login', {replace:true})
        try {
            getRegistrationRedirect(redirect_id)
            .then(res=>{
                if (res.status!==200) navigate('/login', {replace:true})
                else{
                    res.json().then(data=>{
                        setEmail(data?.username)
                    })
                }
            })
            .catch(e=>{
                console.log(e)
                navigate('/login', {replace:true})
            })

        } catch (error) {
            console.log(error)
            navigate('/login', {replace:true})
        }
    }, [])
    return (
        <>
        {email&&<CheckEmail email_address={email.includes('@')?email:undefined} onBack={()=>navigate('/register')} />}
        </>
    )
}